import moment from 'moment';
import recordStatus from '../constants/recordStatus';
import firebaseApp from '../services/Firebase';

let lastUpdated = null;

const shouldRenewCostCenters = async () => {
  return moment().isAfter(moment(lastUpdated).add(1, 'days'));
};

const getNewCostCenters = async (orgId, onlyActive = false) => {
  let snap = firebaseApp.getCostCentersFromOrganization(orgId);

  if (onlyActive) snap = snap.where('status', '==', recordStatus.ACTIVE);

  return await snap.get({ source: 'server' });
};

export const getCostCenters = async (orgId, onlyActive) => {
  const storageSnapshot = await firebaseApp
    .getCostCentersFromOrganization(orgId)
    .get({ source: 'cache' });

  if (storageSnapshot.exists) {
    const shouldRenew = shouldRenewCostCenters();
    if (shouldRenew) {
      lastUpdated = moment();
      return await getNewCostCenters(orgId, onlyActive);
    }

    return storageSnapshot;
  }

  return await getNewCostCenters(orgId, onlyActive);
};

export const loadCostCenters = async (orgId, onlyActive = false) => {
  const costCenterSnap = await firebaseApp
    .getCostCentersFromOrganization(orgId, onlyActive)
    .get();

  const costCenters = [];
  costCenterSnap.forEach((costCenterSnap) => {
    const label = costCenterSnap.data().name;

    if (typeof label === 'string') {
      costCenters.push({
        value: costCenterSnap.id,
        label,
      });
    }
  });

  return costCenters;
};

export const addMultipleCostCenters = (orgId, costCenterKeys) => {
  const promises = costCenterKeys.map(async (key) => {
    if (typeof key === 'string') {
      const docRef = await firebaseApp.createCostCenterFromOrganization(orgId, {
        name: key,
      });
      return { label: key, value: docRef.id };
    } else return null;
  });

  return Promise.all(promises);
};
